import { gql } from '@apollo/client';

export const GET_QUALITATIVE_FACTORS = gql`
  query GetQualitativeFactors($showDefaults: Boolean) {
    getQualitativeFactors(showDefaults: $showDefaults) {
      description
      name
      uuid
      hasItApplications
    }
  }
`;

export const GET_QUALITATIVE_FACTOR = gql`
  query GetQualitativeFactor($uuid: String!) {
    getQualitativeFactor(uuid: $uuid) {
      description
      isDefault
      name
      uuid
    }
  }
`;

export const CREATE_QUALITATIVE_FACTOR = gql`
  mutation CreateQualitativeFactor($data: CreateQualitativeFactorInput!) {
    createQualitativeFactor(data: $data) {
      description
      name
      uuid
    }
  }
`;

export const UPDATE_QUALITATIVE_FACTOR = gql`
  mutation UpdateQualitativeFactor($data: UpdateQualitativeFactorInput!) {
    updateQualitativeFactor(data: $data) {
      description
      name
      uuid
    }
  }
`;

export const DELETE_QUALITATIVE_FACTOR = gql`
  mutation DeleteQualitativeFactor($uuid: String!) {
    deleteQualitativeFactor(uuid: $uuid)
  }
`;
